import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCall } from "../serviceCall"
import { setLoading } from "../../feature/authSlice";

export const UpdateInvoiceApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true))
      console.log("API call initiated with data:", data); // Log the data being sent

      const response = await serviceCall({
        url: apiConstants.Invoices.UPDATE_INVOICE,
        method: 'post',
        data: data,
      });

      console.log("API call successful with response:", response); // Log the successful response
      if (callback) {
        dispatch(setLoading(false))
        callback(response);
      }
    } catch (error) {
      console.error("API call failed with error:", error); // Log the error
      dispatch(setLoading(false))
      toast.error(compileErrors(error.response?.data?.error)); // Log the error message for debugging
      if (errorCallBack) {
        dispatch(setLoading(false))
        errorCallBack(error.response);
      }
    }
  };
};
